import { type SuggestedAction } from '../../../../types/ai';
import { cn } from '../../../../utils/cn';

export const WelcomeEditorialLinks = ({ actions }: { actions: SuggestedAction[] }) => {
  const links = actions.filter((action) => String(action.externalUrl ?? '').trim());
  if (links.length === 0) return null;

  return (
    <div className="mt-4 border-t border-black/10 pt-3">
      <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-text-grey">
        För inspiration
      </p>
      <div className="flex flex-wrap gap-2">
        {links.map((action, index) => (
          <a
            key={`${action.actionId ?? action.label}-${index}`}
            href={String(action.externalUrl).trim()}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
              'inline-flex items-center gap-2 rounded-sm border border-black/10 bg-[#f8f5ef] px-3 py-2 text-sm text-brand-blue transition-colors duration-200',
              'hover:border-brand-blue hover:bg-white',
            )}
          >
            <span>{action.label}</span>
            <span aria-hidden="true" className="text-xs">
              ↗
            </span>
          </a>
        ))}
      </div>
    </div>
  );
};
